import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";

var _dec, _class, _class2, _temp;

/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 - present Instructure, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import themeable from '@instructure/ui-themeable';
import DeviceSelection from '../DeviceSelection';
import FileSave from '../FileSave';
import StartOver from '../StartOver';
var styles = {
  componentId: 'bnDpk',
  template: function template(theme) {
    return "\n\n.bnDpk_crZr{align-items:center;display:flex;justify-content:center;margin:".concat(theme.margin || 'inherit', ";max-width:").concat(theme.maxWidth || 'inherit', ";min-height:").concat(theme.height || 'inherit', ";width:").concat(theme.width || 'inherit', "}\n\n.bnDpk_rFBJ{display:flex;flex:1}\n\n.bnDpk_qrQc{justify-content:flex-end}");
  },
  'container': 'bnDpk_crZr',
  'flexed': 'bnDpk_rFBJ',
  'right': 'bnDpk_qrQc'
};
import theme from './theme';
import { READY, RECORDING, PREVIEWSAVE, SAVING, FINISHED } from '../../../constants/CaptureStates';
/**
---
private: true
---
**/

var Controller = (_dec = themeable(theme, styles), _dec(_class = (_temp = _class2 = /*#__PURE__*/function (_Component) {
  _inherits(Controller, _Component);

  function Controller() {
    _classCallCheck(this, Controller);

    return _possibleConstructorReturn(this, _getPrototypeOf(Controller).apply(this, arguments));
  }

  _createClass(Controller, [{
    key: "render",
    value: function render() {
      var _this = this;

      var StartGuard = function StartGuard(state) {
        if (state !== READY) return null;
        return React.createElement("div", {
          className: styles.container
        }, React.createElement(DeviceSelection, {
          variant: "audio",
          devices: _this.props.devices.audioinput,
          selectedDeviceId: _this.props.audioDeviceId,
          actions: _objectSpread({}, _this.props.actions)
        }), _this.props.children, React.createElement(DeviceSelection, {
          variant: "video",
          devices: _this.props.devices.videoinput,
          selectedDeviceId: _this.props.videoDeviceId,
          actions: _objectSpread({}, _this.props.actions)
        }));
      };

      var FinishGuard = function FinishGuard(state) {
        var _classNames;

        if (state !== RECORDING) return null;
        return React.createElement("div", {
          className: styles.container
        }, React.createElement("div", {
          className: styles.flexed
        }), React.createElement("div", {
          className: styles.flexed
        }, _this.props.children), React.createElement("div", {
          className: classNames((_classNames = {}, _defineProperty(_classNames, styles.flexed, true), _defineProperty(_classNames, styles.right, true), _classNames))
        }, React.createElement(StartOver, {
          actions: _objectSpread({}, _this.props.actions)
        })));
      };

      var SaveGuard = function SaveGuard(state) {
        var _classNames2;

        if (![PREVIEWSAVE, SAVING, FINISHED].includes(state)) return null;
        return React.createElement("div", {
          className: styles.container
        }, React.createElement("div", {
          className: styles.flexed
        }, React.createElement(FileSave, {
          captureState: state,
          fileName: _this.props.fileName,
          actions: _objectSpread({}, _this.props.actions)
        })), React.createElement("div", {
          className: classNames((_classNames2 = {}, _defineProperty(_classNames2, styles.flexed, true), _defineProperty(_classNames2, styles.right, true), _classNames2))
        }, React.createElement(StartOver, {
          actions: _objectSpread({}, _this.props.actions)
        })));
      };

      var DefaultGuard = function DefaultGuard() {
        return React.createElement("div", {
          className: styles.container
        }, _this.props.children);
      };

      var captureState = this.props.captureState;
      return StartGuard(captureState) || FinishGuard(captureState) || SaveGuard(captureState) || DefaultGuard();
    }
  }]);

  Controller.displayName = "Controller";
  return Controller;
}(Component), _class2.propTypes = {
  children: PropTypes.node,
  captureState: PropTypes.string.isRequired,
  fileName: PropTypes.string.isRequired,
  devices: PropTypes.shape({
    audioinput: PropTypes.array,
    videoinput: PropTypes.array
  }).isRequired,
  audioDeviceId: PropTypes.string.isRequired,
  videoDeviceId: PropTypes.string.isRequired,
  actions: PropTypes.object.isRequired // eslint-disable-line react/forbid-prop-types

}, _class2.defaultProps = {
  children: []
}, _temp)) || _class);
export default Controller;